import { Component, OnInit } from '@angular/core';
import { DynamicFormOptions, FieldConfig, FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { TestService } from '../test.service';

@Component({
    selector: 'app-style-test',
    templateUrl: './style-test.component.html',
    styleUrls: ['./style-test.component.scss'],
    standalone: false
})
export class StyleTestComponent implements OnInit {

  regConfig5: FieldConfig[] = [];

  form2Opts: DynamicFormOptions = {
  
  };

  loadingInit: boolean = true;
  showErr: boolean = false;

  constructor(private testService: TestService) {
    this.regConfig5= [
      {
        type: FieldTypeEnum.input,
        label:'Username',
        name: 'username',
        value: '',
      },
      {
        type: FieldTypeEnum.button,
        label:'TEST',
        name: 'submit',
        value: 'Login',
        buttonType:'submit',
      },
      {
        type: FieldTypeEnum.input,
        label:'Password',
        name: 'pwd',
        value: '',
      }
    ];
  }
  
  ngOnInit(): void {
    this.testService.loadingAuthSubject$.subscribe({
      next: (data: boolean) => {
        this.loadingInit = !data;

        if(data == false) {
          this.showErr = true;
        }
      },
    });
  }

  submit2(e: any) {

  }

  switchChange(e: any) {

  }

  checkbocChange(e: any) {
    
  }

  

}
